<!--
  @component App
  @description 挂载全局 Element Plus 配置、路由出口和异步下载中心。
-->
<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { onMounted } from 'vue'
import { useTheme, watchSystemPreference } from '@/composables/useTheme'
import DownloadCenterPanel from '@/components/DownloadCenterPanel.vue'

useTheme()

onMounted(() => {
  watchSystemPreference()
})
</script>

<template>
  <div>
    <el-config-provider :locale="zhCn" :z-index="10000">
      <router-view></router-view>
      <DownloadCenterPanel />
    </el-config-provider>
  </div>
</template>
